const SelectAndConnect = {
  SUBMIT_BUTTON_TEXT: 'Complete Your Quote Request',
};

export default SelectAndConnect;
